import React from 'react';

const Disclaimer = () => {
  return (
    <section id="disclaimer" className="legal-section">
      <div className="container">
        <h2 className="section-title">Aviso Legal</h2>
        <div className="legal-content">
          <p>
            <strong>Importante:</strong> Somos un servicio independiente de gestión de citas y no estamos afiliados a ninguna autoridad gubernamental española.
          </p>
          <p>
            Cita Facil es un servicio privado que ayuda a gestionar y monitorear la disponibilidad de citas de extranjería.
            No garantizamos la obtención de citas, pero trabajamos diligentemente para ayudar a nuestros clientes a conseguir citas confirmadas.
          </p>
          <p>
            Todos los servicios están sujetos a la disponibilidad de citas en el sistema oficial de extranjería.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
